<div class="container">
    <div class="row">
        <div class="col-12 text-center">
            <h1>BIENVENIDO A XMARTBUSINESS</h1>
            <p style="color: white;">Se ha registrado de forma exitosa en XmartBusiness&reg;. Hemos eviado un correo electr&oacute;nico a la cuenta que
                registr&oacute;. Por favor vaya a su bandeja de entrada y siga el link de activaci&oacute;n para dar de alta su
                cuenta.</p>
            <a class="btn btn-primary" [routerLink]="['/Login']">INGRESAR</a>
        </div>
    </div>
</div>